export default "__VITE_ASSET__CxqKe_Ty__"